import React, { FC } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Author } from '@fiverr-private/cms_ui';
import { logger } from '@fiverr-private/obs';
import { Author as AuthorType } from '../../../../../../shared/types';

export const AboutAuthor: FC<AuthorType> = (props) => {
  const { webLink, photo, title, heading, authorName, biography } = props;
  const { image, alt } = photo || {};

  if (!photo) {
    logger.error(`Author photo is missing for ${authorName}`, { ...props });
  }

  return (
    <Author
      url={webLink}
      photo={{
        srcset: [image],
        alt,
        type: 'mediaAsset',
        tag: 'image',
      }}
      title={title}
      heading={heading || translate('fiverr_guides.guide.author.heading')}
      authorName={authorName}
      biography={biography}
    />
  );
};
